import './leaders-view.styles.scss';
import { Link } from 'react-router-dom';
import { TEAM_CATEGORIES, formatTeamValue } from '@shared/teamStats.js';
import { recordText } from '@/utils/leagueLabels';
import TeamBadge from '@/components/SHARED/team-badge/team-badge.component';
import SortTh from '@/components/SHARED/sort-th/sort-th.component';
import { useSortable } from '@/utils/useSortable';

// Every team and every team stat in one table; tap a column to sort by it
// (best first: lowest first where lower is better).
// stats: {teamId: team stats}; teams: summary/teams map.
const TeamStatsTable = ({ stats, teams, teamLink, highlightId, playoffs }) => {

    const sorter = useSortable({ key: 'netRtg', dir: 'desc' });
    const base = Object.entries(stats)
        .filter(([id, s]) => s?.gp > 0 && teams?.[id])
        .map(([id, s]) => ({ id, s, team: teams[id] }));
    const rows = sorter.apply(base, {
        team: r => r.team.name,
        gp: r => r.s.gp,
        ...Object.fromEntries(TEAM_CATEGORIES.map(c => [c.key, r => c.value(r.s)])),
    });

    if (rows.length === 0) return <p className='meta'>Team stats appear once games have been played.</p>;

    return (
        <div className='g-card'>
            <p className='meta'>Tap a column to sort by it.</p>
            <div className='table-scroll'>
                <table className='g-table leaders-table team-stats-table'>
                    <thead>
                        <tr>
                            <SortTh k='team' label='Team' sorter={sorter} first='asc' />
                            <th className='num'>W-L</th>
                            {TEAM_CATEGORIES.map(c => (
                                <SortTh key={c.key} k={c.key} label={c.short} title={c.label} sorter={sorter}
                                    first={c.low ? 'asc' : 'desc'} className='num' />
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map(r => (
                            <tr key={r.id} className={r.id === highlightId ? 'highlight' : ''}>
                                <td>
                                    <Link to={teamLink(r.id)} className='team-link'>
                                        <TeamBadge team={r.team} size='sm' />
                                        <span className='team-name'>{r.team.name}</span>
                                    </Link>
                                </td>
                                <td className='num'>{playoffs ? `${r.team.record?.postW ?? 0}-${r.team.record?.postL ?? 0}` : recordText(r.team.record)}</td>
                                {TEAM_CATEGORIES.map(c => (
                                    <td key={c.key} className={`num ${sorter.sort?.key === c.key ? 'value' : ''}`}>{formatTeamValue(c, c.value(r.s))}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default TeamStatsTable
